import { Pipe, PipeTransform } from '@angular/core';
import { Ability, subject } from '@casl/ability';

@Pipe({
    name: 'able',
    standalone: true
})
export class CustomAblePipe implements PipeTransform {
    constructor(
        private ability: Ability,
    ) { }
    // *ngIf="'manage-team' | able: 'Project' : {assessment_status: 'approved'}:user"
    transform(action: string, subjectType: any, user: any, subjectObj: any = null): boolean {
        console.log("action", action);
        console.log("subject", subjectType);
        console.log("subjectObj", subjectObj);
        console.log("abilities", user!.abilities);

        this.ability.update(user!.abilities as any);

        console.log("this.ability.rules", this.ability.rules);
        console.log(this.ability.can(action, subject(subjectType, subjectObj)));

        if (subjectObj) {
            return this.ability.can(action, subject(subjectType, subjectObj));  // Check permission with the actual object
        }
        return this.ability.can(action, subjectType);  // Fallback to just subject type
    };
};